import * as way from 'app/libs/core/PubSubWays';
import * as e from 'app/constants/TourBuilderEvents';
import { MandatoryPointsList, Type } from 'app/constants/TourPoints';
import mapUtils from 'app/libs/Utils/mapUtils';
import { tourPoint, getEmptyPoint } from '../../../../libs/map/drive/TourPoint';

import { useTimestamp } from '../../../Utility/Service/keepTimestamp.service';
import { openNotificationWithIcon } from '../../../Utility/notificationMessage';
import { isOnLine } from '../../../../libs/Utils/enviropment';

// const LIMIT_COUNT_TOUR_POINTS = 50;
// let temporaryDataForPoint = null;
let temporaryPointData = null;
const deletePolyDelay = null;
let tempLocToAvoidDouble = null;

function TourBuilder(
  actions,
  partData,
  dataPoly,
  useSubscribers,
  trigger,
  history,
  partPointsData
) {
  const [{ sub }, setMediator] = useSubscribers();
  const [addToProgress, removeFromProgress] = useTimestamp();
  let isFirstTourView = true;
  let lastChanges = null;
  let lastAdressTime = null;

  const correctPointList = {};
  const correctLaunchDelay = {};

  setMediator(this);

  partData.setMediator(this);
  dataPoly.setMediator(this);
  trigger.setMediator(this);

  const isEditMode = () => actions.getMode();

  const isPointExists = (point) =>
    point && point.id && partData.isPointExists(point.id);

  const isNotEmptyPoint = (id) =>
    partData.getPointById(id) && !partData.getPointById(id).isEmpty;

  const wasPolyChanged = (historyPoint) => {
    const id = historyPoint.getId();
    const historyPolyParams = `${historyPoint.getPrevCoordStr()}_${historyPoint.getCoordStr()}`;
    const point = { ...partData.getPointById(id) };
    const currentPolyParams = `${point.getPrevCoordStr()}_${point.getCoordStr()}`;

    return historyPolyParams !== currentPolyParams;
  };

  const getAvoidSettings = () => ({
    unpaved: actions.unpaved(),
    highway: actions.highway(),
    ferry: actions.ferry(),
  });

  const showPointPoly = (point, isEdit, oncePointData) => {
    dataPoly.showPolyByPoint({
      point,
      isEdit,
      avoid: getAvoidSettings(),
      isShapingVisible: actions.isShapingVisible(),
      oncePointData,
    });
  };

  const addNewPoint = (
    point,
    { index, isLoading, mapZoom, isLastVia, isStaightIndex }
  ) => {
    if (partData.isIndexBeforeLastVia(index) && point.canBeLast) {
      isLastVia = true;
    }
    partData.addPointByType(point, index, isLastVia, isStaightIndex);
    if (!point.isEmpty) trigger.showPointOnMap(point, isLoading, mapZoom);
  };

  const removePointById = (id) => {
    if (isNotEmptyPoint(id)) {
      partPointsData.removePointById(id);
      trigger.removeTourPointOnMap(id);
      dataPoly.removePolyByPointId(id);
    }
    partData.removePoint(id);
  };

  const changeCursorIcon = (isEditable) => {
    let cursor = null;
    if (isEditable && actions.isRidePlanMode()) {
      cursor = partData.getNextPointType();
    } else if (
      actions.isToPointMode() &&
      partData.isExistsStartPoint() &&
      !partData.isExistsEndPoint()
    ) {
      cursor = Type.END;
    }
    if (isEditable) actions.changeCursorWrapperClassName(cursor);
  };

  const updateTourDataFromHistory = (points) => {
    if (isEditMode()) {
      if (points && points.length > 0) {
        const changedIds = [];
        let isAfterNewPoint = false;
        points.forEach((pt, i) => {
          if (isPointExists(pt)) {
            if (isAfterNewPoint || wasPolyChanged({ ...pt }))
              showPointPoly({ ...pt }, true, false, true);

            partData.updatePointDataById(pt.id, pt, true);
            partData.updatePointPosition(pt.id, i);
            changedIds.push(pt.id);
            isAfterNewPoint = false;
          } else {
            const index = i ? i - 1 : 0;
            addNewPoint({ ...pt }, { index });
            changedIds.push(pt.getId());
            showPointPoly({ ...pt }, true, false, true);
            isAfterNewPoint = true;
          }
        });
        const excessIds = partData.getExcessPoints(changedIds);
        excessIds.forEach((id) => {
          removePointById(id);
        });
        changeCursorIcon(true);
        partData.cleanAutocorrectedPoints();
        partData.fixPointTypes(true);
      }
    }
  };

  const partPointsSaveInReduxWithTimestamp = ({
    timestamp,
    isEditable = isEditMode(),
  }) => {
    const list = partData.getCurrentPartData(
      isEditable,
      actions.getActiveMode()
    );
    actions.upPointsTourPartWithTimestamp(timestamp, list);
    changeCursorIcon(isEditable);
  };

  const innerCnangesCompleted = () => {
    addToProgress();
    const timestamp = removeFromProgress();
    if (timestamp) partPointsSaveInReduxWithTimestamp({ timestamp });
  };

  const changeHistoryState = (points) => {
    mapUtils.cancelRespByTopic('route');
    updateTourDataFromHistory(points);
    actions.udatePartPointsData(partPointsData.getList());
    innerCnangesCompleted();
  };

  const goPrevHistoryState = () => {
    const points = history.goPrev(partData.getCurrentPartData(true));
    if (points && points.length) changeHistoryState(points);
  };

  const goNextHistoryState = () => {
    const points = history.goNext();
    if (points && points.length) changeHistoryState(points);
  };

  const undoKeyPressCtrlZ = (ev) => {
    if (isEditMode()) {
      const evtobj = window.event ? window.event : ev;
      if (evtobj.keyCode === 90 && evtobj.ctrlKey) {
        goPrevHistoryState();
      }
    }
  };

  document.onkeydown = undoKeyPressCtrlZ;

  const clearPartData = (obj = {}) => {
    const { wasEditModeChanged = false } = obj;
    if (wasEditModeChanged) {
      trigger.cleanData(false);
    } else {
      mapUtils.cancelRespByTopic('route');
      trigger.cleanData();
    }
    dataPoly.clear();
    partData.clear();
    history.clear();
    sub.destroy();
  };

  const clearData = () => {
    trigger.cleanData();
    dataPoly.clear();
    partData.clear();
    history.clear();
  };

  const tbDistructItself = () => {
    clearPartData();
    document.onkeydown = null;
  };

  const tryLoadPolyline = (wasEditModeChanged) =>
    dataPoly.load(
      actions.getCurPartPoly(),
      !isEditMode() && isFirstTourView,
      wasEditModeChanged
    );

  const getPointSiblings = (currentPoint) => {
    const nextId =
      typeof currentPoint.getNextId === 'function'
        ? currentPoint.getNextId()
        : 0;
    const prevId =
      typeof currentPoint.getPrevId === 'function'
        ? currentPoint.getPrevId()
        : 0;
    return { prevId, nextId };
  };

  const isntPointTypeAvailable = (type) =>
    (type === Type.VIA && !actions.isCorrectViaAvailable()) ||
    (type === Type.DRAG && !actions.isCorrectDragAvailable());

  const getCoordStatus = (currentPoint) =>
    +isntPointTypeAvailable(currentPoint.getType()) ||
    currentPoint.keppCurrentCoord;

  const checkPointCorrection = (pointId, obj = null) => {
    const currentPoint = partData.getPointById(pointId);
    if (!currentPoint) return {};
    const { prevId, nextId } = getPointSiblings(currentPoint);
    const keppCurrentCoord = getCoordStatus(currentPoint);
    if (!obj) {
      obj = { isWithoutReverse: true };
    }
    if (isEditMode()) {
      trigger.launchTourCorrection({
        ...obj,
        prevId,
        pointId,
        nextId,
        keppCurrentCoord,
      });
    }

    return {
      prevId,
      nextId,
    };
  };

  const setDefaultPoints = () => {
    MandatoryPointsList.forEach((type) => {
      if (actions.isToPointMode() && type === Type.VIA) {
        return;
      }
      if (
        (actions.isRoundTripMode() || actions.isFreeHandMode()) &&
        (type === Type.VIA || type === Type.END)
      ) {
        return;
      }
      partData.addPointByType(getEmptyPoint(type));
    });
  };

  const partDataWasChanged = (isEditable, delay = 700) => {
    if (lastChanges) {
      clearTimeout(lastChanges);
    }
    lastChanges = setTimeout(() => {
      actions.upPointsTourPart(
        partData.getCurrentPartData(isEditMode(), actions.getActiveMode()),
        isEditable
      );
      changeCursorIcon(isEditMode());
    }, delay);
  };

  const isOnlyStartSet = () =>
    partData.getLastNotEmptyPoint() &&
    partData.getLastNotEmptyPoint().type === Type.START;

  const loadTourDataCurrentPart = ({
    tourData,
    isEditable,
    wasEditModeChanged,
    pointsData,
  }) => {
    if (!partData.getCountPoints()) {
      const isEachPolyAvailable = tryLoadPolyline(wasEditModeChanged);
      if (tourData && tourData.points && tourData.points.length > 0) {
        const len = tourData.points.length;
        const { points } = tourData;
        let wasAutocorrectionManualyDisabled = false;
        if (actions.isAutocorrectionEnabled()) {
          actions.changeAutoCorrectStatus(false);
          wasAutocorrectionManualyDisabled = true;
        }
        points.forEach((pt, it) => {
          const isLast = it === len - 1;
          const { unique_id: uniqueId } = pt;
          const point = tourPoint({
            ...pt,
            draggable: isEditable,
            id: +uniqueId,
          });
          const oncePointData =
            pointsData && pointsData[uniqueId] ? pointsData[uniqueId] : {};
          addNewPoint(
            { ...point },
            { isLoading: true, mapZoom: tourData.map_zoom }
          );
          if (isEachPolyAvailable) {
            showPointPoly(
              { ...partData.getPointById(point.getId()) },
              isEditMode(),
              false,
              true,
              false,
              oncePointData,
              points
            );
            setTimeout(() => {
              checkPointCorrection(point.id);
              if (isLast) {
                const isOnlyCentering = isOnlyStartSet() || !(len > 1);
                trigger.entireTour(isOnlyCentering);
                if (wasAutocorrectionManualyDisabled) {
                  actions.changeAutoCorrectStatus(true);
                }
              }
            }, 2000);
          } else if (!isFirstTourView && !point.isEmpty) {
            trigger.updatePolyHandlers(isEditMode(), point.getId());
            if (isLast) {
              if (wasAutocorrectionManualyDisabled) {
                actions.changeAutoCorrectStatus(true);
              }
            }
          }
        });
        changeCursorIcon(isEditable);
      } else if (isEditable) {
        setDefaultPoints();
        partDataWasChanged(isEditable);
      }
      if (
        isEditable &&
        partData.getCountPoints() < 3 &&
        actions.isRidePlanMode()
      ) {
        partData.fixPointTypes(true);
        partDataWasChanged(isEditable);
      }
      isFirstTourView = false;
    }
  };
  const isExistsOnMap = (pt) => {
    const lastPoint = partData.getLastNotEmptyPoint();
    return lastPoint.getCoordStr() === `${pt.lng},${pt.lat}`;
  };
  const loadTourDataFromGPS = ({ points }) => {
    const len = points.length;
    let wasAutocorrectionManualyDisabled = false;
    if (len > 0) {
      if (actions.isAutocorrectionEnabled()) {
        actions.changeAutoCorrectStatus(false);
        wasAutocorrectionManualyDisabled = true;
      }
      actions.loadingDataStatusGPS({ fetching: true, fetched: false });
      points.forEach((pt, it) => {
        if (!pt.lat || !pt.lng) return;
        if (!pt.type) {
          pt.type = Type.VIA;
          if (it === 0) pt.type = Type.START;
        }
        if (partData.isCurrPartCompleted() && pt.type === Type.START) {
          pt.type = Type.VIA;
          if (isExistsOnMap(pt)) return;
        }
        const isLast = it === len - 1;
        if (isLast) {
          pt.type = Type.END;
        }
        const point = tourPoint({ ...pt, draggable: true });
        addNewPoint({ ...point }, { isLoading: true });
        showPointPoly(
          { ...partData.getPointById(point.getId()) },
          isEditMode(),
          false,
          true,
          false,
          {},
          points
        );
        setTimeout(() => {
          checkPointCorrection(point.id);
          if (isLast) {
            trigger.entireTour();
            if (wasAutocorrectionManualyDisabled) {
              actions.changeAutoCorrectStatus(true);
            }
          }
        }, 2000);
      });
      changeCursorIcon(true);
      partData.removeEmptyPoints();
    }
  };

  const showTemporaryPointPoly = (pointId, from, to) => {
    dataPoly.showTemporaryPolyByPoint({
      pointId,
      from,
      to,
      avoid: getAvoidSettings(),
    });
  };

  const isWithinAcceptLimit = () => {
    return true; // unlimit tour points
    // const count = partData.getCountPoints();
    // if( count < LIMIT_COUNT_TOUR_POINTS ){
    //     return true;
    // }else{
    //     return actions.isAddingPointAvailable( true );
    // }
  };

  const seveCurrentHistoryState = () => {
    if (isEditMode())
      history.save(partData.getCurrentPartData(true, actions.getActiveMode()));
  };

  const setEmptyPoint = ({ type, index }) =>
    partData.addPointByType(getEmptyPoint(type), index, false, true);

  const addEmptyViaPoint = (obj) => {
    isWithinAcceptLimit();
    seveCurrentHistoryState();
    setEmptyPoint(obj);
    partDataWasChanged(true, 10);
  };

  const setImagineIndexViaPoint = (type) => {
    const index = type === 'via' ? '0' : undefined;
    return index;
  };

  const saveWorkHomeAddressToStore = ({
    iconType = null,
    address,
    lat,
    lng,
    loc,
  }) => {
    if (iconType && address && (lat || lng)) {
      const dataAddress = {
        value: address,
        lat,
        lng,
        loc,
      };
      if (iconType === Type.HOME) {
        actions.saveHomeAddressFromMap(dataAddress);
      } else if (iconType === Type.WORK) {
        actions.saveWorkAddressFromMap(dataAddress);
      }
    }
  };

  const saveLatestPointHistory = (obj = {}) => {
    if (lastAdressTime) clearTimeout(lastAdressTime);
    lastAdressTime = setTimeout(() => {
      actions.saveToLatestSearchAddress(obj);
      actions.loadingDataStatusGPS({ fetching: false, fetched: true });
    }, 2000);
    saveWorkHomeAddressToStore(obj);
  };

  const upPolyByPointId = ({ id, isFixed, isLoading, isWithoutReverse }) => {
    showPointPoly(
      { ...partData.getPointById(id) },
      isEditMode(),
      isFixed,
      isLoading,
      isWithoutReverse
    );
  };

  const launchCorrectionData = (obj, pointId, isLastLaunch = false) => {
    const { prevId, nextId } = checkPointCorrection(pointId, obj);
    if (!isLastLaunch) {
      if (prevId > 0) launchCorrectionData(obj, prevId, true);
      if (nextId > 0) launchCorrectionData(obj, nextId, true);
    }
  };

  const correctTourPointLauncher = (event, obj) => {
    if (obj.currentPointId > 0) {
      if (!correctPointList[event]) {
        correctPointList[event] = new Set();
      }

      if (correctLaunchDelay[event]) {
        clearTimeout(correctLaunchDelay[event]);
      }

      correctPointList[event].add(obj.currentPointId);

      correctLaunchDelay[event] = setTimeout(() => {
        Array.from(correctPointList[event]).forEach((pointId) => {
          launchCorrectionData(obj, pointId);
        });
        correctPointList[event].clear();
      }, 1000);
    }
  };

  const onGetDirection = (ev, { arrDistRoutes, point }) => {
    if (!ev) {
      console.info('Internet error');
      return;
    }
    arrDistRoutes.push({
      routeDistance: ev.routeSummary.totalDistance,
      osrmData: ev,
      point,
    });
    if (arrDistRoutes.length > 1) {
      arrDistRoutes.sort((a, b) => a.routeDistance - b.routeDistance);

      const {
        lat,
        lng,
        number,
        type,
        draggable = true,
        iconType,
        place_type,
        place_id,
        canBeLast,
      } = arrDistRoutes[0].point;

      const poi = tourPoint({
        lat,
        lng,
        number,
        type,
        draggable,
        iconType,
        isNotStickedToRoad: true,
        canBeLast,
        place_type,
        place_id,
      });

      if (poi) {
        if (poi.number) {
          addNewPoint(
            { ...poi },
            { index: poi.number - 1, isStaightIndex: true }
          );
        } else if (poi.number === 0) {
          addNewPoint({ ...poi }, { index: poi.number, isStaightIndex: true });
        }
        showPointPoly({ ...partData.getPointById(poi.getId()) }, isEditMode());
        partData.updateNextPointData(poi.getId());
        correctTourPointLauncher(way.DRIVE_MAP_CLICK, {
          currentPointId: poi.getId(),
          isWithoutReverse: true,
        });
        partDataWasChanged(true);
      }
    }
  };

  const detectFastestViaPointPosition = (data, canBeLast = false) => {
    const point = tourPoint({ ...data, isNotStickedToRoad: true });
    const listSettings = partData.getListClosePointSettings(
      point,
      mapUtils.getDistance
    );
    const arrDistRoutes = [];
    for (let i = 0; i < 2; i++) {
      const option = listSettings[i] ? listSettings[i].options : null;
      const point = listSettings[i] ? listSettings[i].point : null;
      if (option && point)
        mapUtils.getOSMDirectionsService(
          listSettings[i].options,
          onGetDirection,
          { arrDistRoutes, point: { ...listSettings[i].point, canBeLast } }
        );
    }
  };

  const setTourPointBefore = (data) => {
    if (isEditMode()) {
      const point = tourPoint({ ...data, isNotStickedToRoad: true });
      addNewPoint(
        { ...point },
        { index: partData.detectPointPosBefore(data.nextPointId) }
      );
      return point.getId();
    }
    return 0;
  };

  const needDetectShortestRoutePath = (data) =>
    data &&
    partData.hasTourPoly() &&
    !data.isLastVia &&
    partData.isExistsEndPoint() &&
    data.type !== Type.START &&
    data.type !== Type.END &&
    data.type !== Type.DRAG &&
    partData.getNextPointType() !== Type.START;

  const isEnableUpSinglePoint = (data) => {
    if (!actions.isRidePlanMode() && data.map) {
      return false;
    }
    return true;
  };

  const upSinglePoint = (data) => {
    if (!isEditMode()) return;
    if (!isEnableUpSinglePoint(data)) return;
    partData.cleanAutocorrectedPoints();
    seveCurrentHistoryState();

    let changedPointId = 0;
    let isFixed = data && data.isFixed;
    if (data && data.id && partData.isPointExists(data.id)) {
      changedPointId = data.id;
      const { type, isLastVia } = partData.getPointById(data.id);
      if (data.iconType === Type.HOME) {
        if (type === Type.VIA) {
          data.iconType = undefined;
        } else {
          data.iconType = `${Type.HOME}_${type}`;
        }
      }
      if (data.iconType === Type.WORK) {
        if (type === Type.VIA) {
          data.iconType = undefined;
        }
      }
      isFixed = data.isFixed ? data.isFixed : type === Type.END || isLastVia;
      partData.updatePointDataById(data.id, data);
      isFixed =
        type === Type.START || type === Type.END || isLastVia ? false : isFixed;
      partData.updateNextPointData(data.id, isFixed, false, true);
      partData.updatePrevPointData(data.id, isFixed, false, true);
    } else if (temporaryPointData) {
      const { id } = temporaryPointData;
      const dataWithIconType = {
        ...data,
        iconType: temporaryPointData.iconType,
      };
      if (id === Type.HOME) {
        const point = tourPoint({ ...dataWithIconType });
        point.refreshAddress(() => {}, saveLatestPointHistory);
        return;
      }
      partData.updatePointDataById(id, dataWithIconType);
      partData.updateNextPointData(id);
      upPolyByPointId(id);
    } else if (isWithinAcceptLimit(data)) {
      const type = data.type ? data.type : partData.getNextPointType();
      if (
        data &&
        data.type === Type.VIA &&
        partData.hasTourPoly() &&
        !data.isLastVia
      ) {
        detectFastestViaPointPosition(data, true);
      } else if (needDetectShortestRoutePath(data)) {
        data.type = Type.VIA;
        detectFastestViaPointPosition(data);
        return;
      } else if (data && data.type === Type.DRAG) {
        changedPointId = setTourPointBefore(data);
        partData.updateNextPointData(changedPointId, isFixed);
      } else {
        const { isLastVia, lat, lng } = data;
        const uniqueLocKey = `${lat}_${lng}`;
        if (uniqueLocKey === tempLocToAvoidDouble) {
          // fixed the bug with setting double points after a left click on the map in Safary browser
          tempLocToAvoidDouble = null;
          return;
        }
        tempLocToAvoidDouble = uniqueLocKey;

        const point = tourPoint({ ...data, type, isNotStickedToRoad: true });
        addNewPoint(
          { ...point },
          {
            index: setImagineIndexViaPoint(type),
            isLastVia,
            isStaightIndex: true,
          }
        );
        changedPointId = point.getId();
        if (point.type === Type.START) {
          partData.updateNextPointData(changedPointId);
        }
      }
      setTimeout(() => {
        partData.updatePrevPointData(changedPointId, false, false, true);
      }, 0);
    }

    setTimeout(() => {
      if (changedPointId) {
        showPointPoly(
          { ...partData.getPointById(changedPointId) },
          isEditMode(),
          isFixed
        );
        correctTourPointLauncher(way.DRIVE_MAP_CLICK, {
          currentPointId: changedPointId,
          isFixed,
          isWithoutReverse: true,
        });
      }
      innerCnangesCompleted();
    }, 10);
  };

  const dragSinglePoint = (data) => {
    data.iconType = 'none';
    upSinglePoint(data);
  };

  const createPointByFingerDraw = ({ points, round = false }) => {
    if (round) {
      clearData();
    }
    const len = points.length;

    let wasAutocorrectionManualyDisabled = false;
    if (len > 0) {
      if (actions.isAutocorrectionEnabled()) {
        actions.changeAutoCorrectStatus(false);
        wasAutocorrectionManualyDisabled = true;
      }
      points.forEach((pt, it) => {
        if (!pt.lat || !pt.lng) return;
        if (!pt.type) {
          pt.type = Type.DRAG;
          if (it === 0) pt.type = Type.START;
        }
        if (partData.isCurrPartCompleted() && pt.type === Type.START) {
          pt.type = Type.DRAG;
          if (isExistsOnMap(pt)) return;
        }
        const isLast = it === len - 1;
        if (isLast) {
          pt.type = Type.END;
        }
        const point = tourPoint({
          ...pt,
          draggable: true,
          isNotStickedToRoad: true,
        });
        addNewPoint({ ...point }, { isLoading: true });
        showPointPoly(
          { ...partData.getPointById(point.getId()) },
          isEditMode(),
          false,
          true,
          false,
          {},
          points
        );
        setTimeout(() => {
          checkPointCorrection(point.id);
          if (isLast) {
            if (wasAutocorrectionManualyDisabled) {
              actions.changeAutoCorrectStatus(true);
            }
            partData.correctPointsPositions();
          }
        }, 2000);
      });
      partData.removeEmptyPoints();
    }

    seveCurrentHistoryState();

    if (!round) {
      actions.setFreeHand(false);
      actions.hideFreeHand();
    }
  };

  const showRtPoly = ({ point, isEdit, oncePointData, rtRlCb, ...params }) => {
    dataPoly.showRtPoly({
      point,
      isEdit,
      avoid: getAvoidSettings(),
      isShapingVisible: actions.isShapingVisible(),
      oncePointData,
      rtParams: params,
      rtRlCb,
    });
  };

  const reverseCurrentPart = () => {
    partData.cleanAutocorrectedPoints();
    seveCurrentHistoryState();
    partData.reverse(true);
    partPointsData.clear();
    partData.refreshAllPolylines();
    actions.udatePartPointsData(partPointsData.getList());
  };

  const setTourPointType = ({ customId: id, type, isLastBehind, switcher }) => {
    if (isEditMode()) {
      partData.cleanAutocorrectedPoints();
      seveCurrentHistoryState();
      partData.setPointTypeById(id, type, isLastBehind, switcher);
      if (type === Type.START) {
        partPointsData.updatePointData(id, [], 'unpaved_parts');
        partPointsData.updatePointData(id, [], 'shaping_points');
      }
      changeCursorIcon(true);
      innerCnangesCompleted();
    }
  };

  const setPointRoutePath = ({ pointId, route }) => {
    partData.updatePointRoutePathById(pointId, route);
  };

  const setPartPointsData = (
    pointId,
    uniqueId,
    unpavedParts,
    shapingPointsList,
    isNewGeneratedData
  ) => {
    partPointsData.updatePointData(uniqueId, unpavedParts, 'unpaved_parts');
    partPointsData.updatePointData(
      uniqueId,
      shapingPointsList,
      'shaping_points'
    );
    trigger.upPartPointDataOnMapById({
      pointId,
      unpavedParts,
      shapingPointsList,
      avoid: getAvoidSettings(),
      isShapingVisible: actions.isShapingVisible(),
    });
    if (isNewGeneratedData)
      actions.udatePartPointsData(partPointsData.getList());
  };

  const setShapeUnpavedData = ({
    pointId,
    unpavedParts,
    shapingList,
    allShapeArr,
    isNewGeneratedData,
  }) => {
    const point = partData.getPointById(pointId);
    if (point) {
      let shapingPointsList = [];
      const prevPoint = partData.getPrevPoint(point);
      const prevRoadName = prevPoint ? prevPoint.roadName : '';
      if (shapingList[prevRoadName]) {
        delete shapingList[prevRoadName];
      }
      if (shapingList[point.roadName]) {
        delete shapingList[point.roadName];
      }
      if (Object.keys(shapingList).length > 0 && allShapeArr.length > 0) {
        allShapeArr.forEach((loc, it) => {
          if (Object.values(shapingList).includes(it)) {
            shapingPointsList.push(loc);
          }
        });
      }
      if (!allShapeArr || allShapeArr.length === 0) {
        shapingPointsList = shapingList;
      }
      setPartPointsData(
        pointId,
        point.unique_id,
        unpavedParts,
        shapingPointsList,
        isNewGeneratedData
      );
    }
  };

  const showRtWaypoints = ({ points: waypoints }) => {
    const points = waypoints.map((point) => {
      return {
        lat: point.location[1],
        lng: point.location[0],
      };
    });

    const len = points.length;
    let wasAutocorrectionManualyDisabled = false;
    if (len > 0) {
      if (actions.isAutocorrectionEnabled()) {
        actions.changeAutoCorrectStatus(false);
        wasAutocorrectionManualyDisabled = true;
      }
      points.forEach((pt, it) => {
        if (!pt.lat || !pt.lng) return;
        if (!pt.type) {
          pt.type = Type.DRAG;
          if (it === 0) pt.type = Type.START;
        }
        if (isExistsOnMap(pt)) return;
        const isLast = it === len - 1;
        if (isLast) pt.type = Type.END;
        const point = tourPoint({
          ...pt,
          draggable: true,
          isNotStickedToRoad: true,
        });
        addNewPoint({ ...point }, { isLoading: true });
        showPointPoly(
          { ...partData.getPointById(point.getId()) },
          isEditMode(),
          {}
        );
        setTimeout(() => {
          checkPointCorrection(point.id);
          if (isLast) {
            if (wasAutocorrectionManualyDisabled) {
              actions.changeAutoCorrectStatus(true);
            }
            partData.correctPointsPositions();
          }
        }, 2000);
      });
    }
  };

  const updatePintInfo = ({ id, title, desc, images }) => {
    if (title || desc) partData.updateTitleAndDesc(id, title, desc);
    if (images) partData.updatePointMediaById(id, images);

    innerCnangesCompleted();
  };

  const updatePopUpFullPointData = (id) => {
    const selectedPoint = actions.getTourPointData();
    if (selectedPoint && id === selectedPoint.id)
      actions.setDataSelectedPoint();
  };

  const removeTourPoint = ({ customId }) => {
    if (!isEditMode()) return;
    partData.cleanAutocorrectedPoints();
    seveCurrentHistoryState();
    const point = partData.getPointById(customId);
    partPointsData.removePointById(point.unique_id);
    const existedPointId = partData.removePoint(customId);
    dataPoly.removePolyByPointId(customId);
    correctTourPointLauncher(way.DRIVE_MAP_POINT_REMOVE, {
      currentPointId: existedPointId,
      isWithoutReverse: true,
    });
    innerCnangesCompleted();
    updatePopUpFullPointData(customId);
  };

  const togglePointPreview = (data) => {
    if (data.customId === 0) {
      actions.setDataSelectedPoint();
      return;
    }
    const selectedPoint = partData.getPointById(data.customId);
    if (!selectedPoint || selectedPoint.type === Type.DRAG) {
      actions.setDataSelectedPoint();
    } else if (selectedPoint) {
      const prevPoint = actions.getTourPointData();
      if (
        prevPoint.length === 0 ||
        (selectedPoint && prevPoint.id !== selectedPoint.id)
      )
        actions.setDataSelectedPoint(selectedPoint);
      else actions.setDataSelectedPoint();
    }
  };

  const changePointsOrder = ({
    customId,
    index,
    isLoading = false,
    unique_id: uniqueId,
  }) => {
    let pt = partData.getPointById(customId);
    let ptId = customId;
    if (!pt) {
      pt = partData.getPointById(uniqueId);
      ptId = uniqueId;
    }
    if (
      (pt && pt.number === index && !isLoading) ||
      (pt && pt.number === undefined && index === 0)
    ) {
      // console.log('decline', pt, index, isLoading, customId, uniqueId);
      return;
    }
    partData.cleanAutocorrectedPoints();
    seveCurrentHistoryState();
    const listPointIds = partData.movePoint(ptId, index, isLoading);
    listPointIds.forEach((id) => {
      correctTourPointLauncher(way.DRIVE_LIST_POINT_UPDATE_INDEX, {
        currentPointId: id,
        isWithoutReverse: true,
      });
    });
    innerCnangesCompleted();
  };

  const isCorrectionEnabled = () => actions.getCorrectionStatus();

  const showPolyStrOnMap = ({ latLngs, pointId, partId }) => {
    trigger.showPolyStrOnMap({
      latLngs,
      isEdit: isEditMode(),
      pointId,
      partId,
    });
  };

  const movePointPoly = (obj) => {
    trigger.movePointPoly({ ...obj, avoid: getAvoidSettings() });
  };

  const restoreIfPolyActualInNextState = ({ id }) => {
    const point = { ...partData.getPointById(id) };
    if (point && point.id) showPointPoly(point, true, true);
  };

  const saveToReduxPrevPart = (data) => {
    actions.upPointsTourPart(data, isEditMode(), true);
  };

  const tourPartDevideByPoint = ({ customId }) => {
    if (!isEditMode()) {
      console.info('The function available only in edit mode');
      return;
    }

    const { nextPartStack, points } =
      partData.cutSecondRoutePartByPointId(customId);

    nextPartStack.forEach((id) => {
      partPointsData.updatePointData(id, [], 'unpaved_parts');
      partPointsData.updatePointData(id, [], 'shaping_points');
    });

    const partPos = actions.upPointsTourPart(
      partData.getCurrentPartData()
      // isEditMode()
    );

    actions.tourPartActionHandler(
      'topic',
      {
        nextPartStack,
        points,
        selectedPart: partPos + 2,
        action: 'via_part',
      },
      partData.isCurrPartCompleted()
    );
  };

  const fixedPoints = () => {
    if (partData.isExistsStartPoint() && !partData.isExistsEndPoint()) {
      partData.fixPointEnd();
      innerCnangesCompleted();
    }
    return partData.getCurrentPartData();
  };

  const tourPartActionHandler = async (obj) => {
    //eslint-disable-line
    if (isEditMode()) {
      const prevPart = await fixedPoints();
      saveToReduxPrevPart(prevPart);
    }
    actions.tourPartActionHandler('topic', obj, partData.isCurrPartCompleted());
  };

  const createDragPointOnMovedPoly = (data) => {
    if (data && data.id) {
      const { id, latLng } = data;
      const point = { ...partData.getPointById(id) };
      showTemporaryPointPoly(point.getId(), latLng, point.getPrevCoordStr());
      showTemporaryPointPoly('staticId', latLng, point.getCoordStr());
    }
  };

  const pointMovedOnMap = (data) => {
    if (!isEditMode()) return;

    if (data && data.id) {
      const { id, latLng } = data;
      const point = { ...partData.getPointById(id) };

      if (point.type !== Type.END) {
        const nextPoint = { ...partData.getNextPoint(point) };
        if (nextPoint && typeof nextPoint.getId === 'function')
          showTemporaryPointPoly(
            nextPoint.getId(),
            latLng,
            nextPoint.getCoordStr()
          );
      }
      if (point.type !== Type.START) {
        showTemporaryPointPoly(point.getId(), latLng, point.getPrevCoordStr());
      }
    }
  };

  const setCursorIcon = ({ id, isEditHome = false, isEditWork = false }) => {
    if (isEditHome) {
      temporaryPointData = {
        id,
        iconType: Type.HOME,
        isEditHome,
        isEditWork,
      };
      actions.changeCursorWrapperClassName(Type.HOME);
      partData.removeIconType(Type.HOME);
    } else if (isEditWork) {
      temporaryPointData = {
        id,
        iconType: Type.WORK,
        isEditHome,
        isEditWork,
      };
      actions.changeCursorWrapperClassName(Type.WORK);
      partData.removeIconType(Type.WORK);
    } else {
      temporaryPointData = null;
      changeCursorIcon(isEditMode());
    }
  };

  const setPointWrongCoord = (obj) => {
    partData.setCorrectCoord(obj, !isCorrectionEnabled());
    partDataWasChanged(true);
  };

  const updateRelationPointCoord = (obj) => {
    partData.setCoordRelation(obj, isCorrectionEnabled());
    setTimeout(() => {
      const point = partData.getPointById(obj.customId);
      const nextPostion = partData.getNextWrongRoutePosition(point);
      if (nextPostion) trigger.moveMapToLocation(nextPostion);
    }, 500);
    partDataWasChanged(true);
  };

  const movePointToCorrectPlace = ({
    id,
    isFixed,
    correctLat,
    correctLng,
    isAutocorrection = false,
  }) => {
    if (!isEditMode()) return;
    seveCurrentHistoryState();

    const point = partData.getPointById(id);
    if (
      point &&
      point.id &&
      (point.isWrongCoord() || correctLat || correctLng)
    ) {
      let { correctLat: lat, correctLng: lng } = point;
      const { type, isLastVia } = point;
      const fix = isFixed || type === Type.END || isLastVia;
      lat = correctLat || correctLng ? correctLat : lat;
      lng = correctLat || correctLng ? correctLng : lng;
      partData.updatePointDataById(id, {
        type,
        isLastVia,
        lat,
        lng,
        isAutocorrection,
      });

      partData.updateNextPointData(id, fix);
      if (type === Type.END || isLastVia) {
        partData.updatePrevPointData(id, fix);
      }
      setTimeout(() => {
        showPointPoly({ ...partData.getPointById(id) }, true, true); // was uncomented
        const data = { id, isRemoveCorrectCoord: true };
        partData.setCorrectCoord(data);
        trigger.upPointOnMap(point);
      }, 1000);
      setTimeout(() => {
        const nextPostion = partData.getNextWrongRoutePosition(point);

        if (nextPostion && !isAutocorrection)
          trigger.moveMapToLocation(nextPostion);
      }, 1000);
      partDataWasChanged(true);
    }
  };

  const forceAutocorrecPointPosition = (obj) => {
    movePointToCorrectPlace({ ...obj, isFixed: 1, isAutocorrection: true });
  };

  const isTypeAvailable = (type) =>
    (type === Type.VIA && actions.isCorrectViaAvailable()) ||
    (type === Type.DRAG && actions.isCorrectDragAvailable());

  const isAutocorrectionAvailableForThisPoint = (keppCurrentCoord, type) => {
    return (
      actions.isAutocorrectionEnabled() &&
      !keppCurrentCoord &&
      +isTypeAvailable(type)
    );
  };
  const autocorrecPointPosition = (obj) => {
    const { id, keppCurrentCoord } = obj;
    const type = partData.getPointTypeById(id);
    if (isAutocorrectionAvailableForThisPoint(keppCurrentCoord, type)) {
      movePointToCorrectPlace({ ...obj, isFixed: 1, isAutocorrection: true });
    } else {
      const isOn = isCorrectionEnabled() && isTypeAvailable(type);
      if (isOn) trigger.updateWrongRouteMarkerValue(obj);
      partData.setCorrectCoord(
        { ...obj, keppCurrentCoord: 0, isFixed: true },
        !isOn
      );
    }
  };

  const correctOnlyPointsWithShortestWrongDist = () => {
    partData.onlyPointsWithShortestWrongDist(
      actions.isCorrectViaAvailable(),
      actions.isCorrectDragAvailable()
    );
    partDataWasChanged(true);
  };

  const changeCorrectionStatus = ({ isEnabled, type }) => {
    partData.updateAllPointsRelation(isEnabled, type);
    if (isEnabled && actions.isAutocorrectionEnabled())
      setTimeout(() => {
        correctOnlyPointsWithShortestWrongDist();
      }, 200);
    else partDataWasChanged(true);
  };

  const correctAllWrongRoutes = () => {
    if (!isEditMode()) return;
    partData.cleanAutocorrectedPoints();
    seveCurrentHistoryState();
    partData.correctPointsPositions();
    partDataWasChanged(true);
  };

  const exchagePositionWithNextPoint = (obj) => {
    partData.exchangePositionByPointId(obj);
  };

  const cleanAutocorrectedPoints = ({ id }) => {
    partData.cleanAutocorrectedPoints();
    const point = partData.getPointById(id);
    trigger.upPointOnMap(point);
  };

  const swithcShapingPointsVisibility = () => {
    const pointsData = actions.getPointsData();
    if (typeof pointsData === 'object' && Object.keys(pointsData).length > 0) {
      Object.keys(pointsData).forEach((key) => {
        const point = partData.getPointById(key);
        if (point && point.id) {
          const {
            unpaved_parts: unpavedParts = [],
            shaping_points: shapingPointsList = [],
          } = pointsData[key] || {};
          trigger.upPartPointDataOnMapById({
            pointId: point.id,
            unpavedParts,
            shapingPointsList,
            avoid: getAvoidSettings(),
            isShapingVisible: actions.isShapingVisible(),
          });
        }
      });
    } else if (actions.isShapingVisible()) {
      partData.refreshAllPolylines();
    }
  };

  const clearDeleteDelay = () => clearTimeout(deletePolyDelay);

  const changePointPolyOnMap = (obj) => trigger.changePointPolyOnMap(obj);

  const possiblylity = {
    [e.TB_DISTRUCT_ITSELF]: tbDistructItself,
    [e.TB_DESTROY_SUBSCRIBERS]: sub.destroy,
    [e.TB_SET_SUBSCRIBERS_FROM_VIEW]: sub.set,
    [e.TB_CLEAR_PART_DATA]: clearPartData,
    [e.TB_LOAD_TOUR_DATA_ONE_PART]: loadTourDataCurrentPart,
    [e.TB_CREATE_POINT_ON_MAP]: trigger.showPointOnMap,
    [e.TB_UP_POINT_ON_MAP]: trigger.upPointOnMap,
    [e.TB_SAVE_PART_DATA_IN_REDUX]: partDataWasChanged,
    [e.TB_SAVE_PART_DATA_IN_REDUX_USE_TIMESTAMP]:
      partPointsSaveInReduxWithTimestamp,
    [e.TB_SET_EMPTY_POINT]: setEmptyPoint,
    [e.TB_HISTORY_PREV_STATE]: goPrevHistoryState,
    [e.TB_HISTORY_NEXT_STATE]: goNextHistoryState,
    [e.TB_HISTORY_SAVE_STATE]: seveCurrentHistoryState,
    [e.TB_HISTORY_CLEAR_STATE]: history.clear,
    [e.TB_SHOW_POLY_STR_ON_MAP]: showPolyStrOnMap,
    [e.TB_UP_POLY_ON_MAP_BY_POINT_ID]: upPolyByPointId,
    [e.TB_REMOVE_POINT_ON_MAP_BY_ID]: trigger.removeTourPointOnMap,
    [e.TB_SAVE_LATEST_POINT_HISTORY]: saveLatestPointHistory,
    [e.TB_UPDATE_POINT_ROUTE_PATH]: setPointRoutePath,
    [e.TB_CLEAR_DELETE_DELAY]: clearDeleteDelay,
    [e.TB_MAP_AUTOCORRECT_POINT_COORD]: forceAutocorrecPointPosition,
    [e.TB_POLY_DRIVE_MAP_CHANGE_POLY]: showPolyStrOnMap,
    [e.TB_POLY_DRIVE_MAP_CHANGE_POINT_POLY]: changePointPolyOnMap,
    [e.TB_POLY_DRIVE_MAP_MOVE_POINT_POLY]: movePointPoly,
    [e.TB_UPDATE_POINT_SHAPING_POINTS]: setShapeUnpavedData,
    [e.TB_SHOW_RT_WAYPOINTS]: showRtWaypoints,

    [way.DRIVE_LIST_ADD_EMPTY_VIA_POINT]: addEmptyViaPoint,
    [way.DRIVE_MAP_CLICK]: upSinglePoint,
    [way.DRIVE_MAP_UPLOAD_GPS_DATA]: loadTourDataFromGPS,
    [way.DRIVE_MAP_POINT_DRAGEND]: dragSinglePoint,
    [way.DRIVE_BUILDER_TOUR_REVERSE]: reverseCurrentPart,
    [way.DRIVE_MAP_POINT_SET_TYPE]: setTourPointType,
    [way.DRIVE_MAP_POINT_REMOVE]: removeTourPoint,
    [way.DRIVE_LIST_REMOVE_EMPTY_VIA_POINT]: removeTourPoint,
    [way.DRIVE_MAP_STATIC_POINT_SELECTED]: togglePointPreview,
    [way.DRIVE_LIST_POINT_UPDATE_INDEX]: changePointsOrder,
    [way.DRIVE_BUILDER_PART_ACTION]: tourPartActionHandler,
    [way.AXIOS_BUILDER_CANCELED_POLY_ID]: restoreIfPolyActualInNextState,
    [way.DRIVE_MAP_DRAGED_POINT_MOVED]: pointMovedOnMap,
    [way.DRIVE_MAP_BREAK_POLY_HERE]: createDragPointOnMovedPoly,
    [way.DRIVE_CHANGE_CURSOR_ICON]: setCursorIcon,
    [way.DRIVE_PREVIEW_POINT_UPDATE]: updatePintInfo,
    [way.SAVE_TB_PART_DATA_IN_REDUX]: partDataWasChanged,
    [way.MAP_SET_CORREC_POINT_COORD]: setPointWrongCoord,
    [way.DRIVE_MAPBUILDER_HIDE_WRONG_ROUTE_POPUP]: updateRelationPointCoord,
    [way.DRIVE_BUILDER_MOVE_POINT_CORRECT_PLACE]: movePointToCorrectPlace,
    [way.MOVE_POINTS_SHORT_WRONG_DIST_TO_ROUTE]:
      correctOnlyPointsWithShortestWrongDist,
    [way.CHANGE_CORRECTION_WRONG_ROUTE_STATUS]: changeCorrectionStatus,
    [way.CORRECT_ALL_WRONG_ROUTES_POSITION]: correctAllWrongRoutes,
    [way.MAP_EXCHANGE_WITH_NEXT_POINT]: exchagePositionWithNextPoint,
    [way.MAP_AUTOCORRECT_POINT_COORD]: autocorrecPointPosition,
    [way.MAP_DRIVE_GO_TO_PREVIOUS_TOUR_STATE]: goPrevHistoryState,
    [way.MAP_DRIVE_CLEAR_AUTOCORRECTION_PUPUPS]: cleanAutocorrectedPoints,
    [way.SAVE_TB_UPDATE_ALL_POLYS]: partData.refreshAllPolylines,
    [way.SAVE_TB_SWITCH_SHAPING_UNPAVED_ROUTES]: swithcShapingPointsVisibility,
    [way.DRIVE_BUILDER_PART_DEVIDE_BY_POINT]: tourPartDevideByPoint,
    [way.DRIVE_ADD_POINT_BY_FINGER_DRAW]: createPointByFingerDraw,
    [way.DRIVE_SHOW_RT_POLY]: showRtPoly,
    [way.DRIVE_FIXED_POINTS]: fixedPoints,
    [way.DRIVE_CLEAR_DATA]: clearData,
  };

  const getCommand = (event) => possiblylity[event];

  this.notify = (event, data) => {
    if (!isOnLine()) {
      openNotificationWithIcon('warning', 'Check your internet connection');
      return;
    }
    const command = getCommand(event);
    if (command) {
      command(data);
    } else {
      console.error(`There is no command for event - ${event}`);
    }
  };
}

export default TourBuilder;
